export default __webpack_public_path__ + "static/media/SSI Schaefer.a85d70c4.png";